import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import BookingConfirmation from "../components/BookingConfirmation";
import AuthGuard from "../components/AuthGuard";

const searchSchema = z.object({
  paymentGuid: z.string().optional(),
  magicToken: z.string().optional(),
});

export const Route = createFileRoute("/bookings/$bookingGuid/success")({
  validateSearch: searchSchema,
  component: () => (
    <AuthGuard>
      <BookingConfirmation />
    </AuthGuard>
  ),
});
